import React from 'react';
import { Box, Typography } from '@mui/material';

// ==============================|| DEVELOPMENT WARNING BAR ||============================== //

const DevelopmentWarningBar = () => {
  // Only show if not in production
  const isProduction = (process.env.REACT_APP_PRODUCTION || '').toUpperCase() === 'TRUE';
  
  if (isProduction) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1300, // Higher than dashboard header (1200)
        backgroundColor: '#d32f2f',
        color: '#fff',
        padding: '2px 2px',
        textAlign: 'center',
        borderBottom: '2px solid #b71c1c',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
      }}
    >
      <Typography 
        variant="body2" 
        sx={{ 
          fontSize: '10px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }}
      >
        Development mode | DB in dev mode
      </Typography>
    </Box>
  );
};

export default DevelopmentWarningBar;
